export default {
    charities (state) {
      return state.charities
    },
    selectedCharity (state) {
        return state.selectedCharity
    },
    getCharity: state => (givingId) => {
      return state.charities.find(charity => charity.givingId === givingId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/charities/getters.js